export default __webpack_public_path__ + "images/bf54999338108c002ed64b7f9e8c7012.png";